import React, { useEffect, useRef, useState } from "react";
import TxtRow from "components/Custom/TxtRow";
import RadioBtn from "components/Custom/RadioBtn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Btn from "components/Custom/Btn";

import { COLORS } from "common/colors";
import { DateFunctions } from "common/datefunctions";
import { CRM_LEAD_STATUS, FORMATS, NOTIFY } from "common/config";
import { LABELS, SUCCESS, WARNINGS } from "common/lables";
import { COMMON_JS } from "common/scripts";
import { CRM_APIs } from "apihandlers/crm";
import { withSnackbar } from "notistack";
import AutoComplete from "components/Custom/AutoComplete";

const datajson = require("./grid.json");

interface defaultProps {
  selectedRow;
  childRef: any;
}

const Qualified = (props: any) => {
  const { selectedRow, childRef, areas, onClose } = props;

  const gridRef: any = useRef();
  const partnerGridRef: any = useRef();
  const areasRef: any = useRef(null);
  const nomineeGridRef: any = useRef();
  const familyGridRef: any = useRef();

  const [partnerColumns, setPartnerColumns] = useState<any>([
    // {
    //   key: "partner",
    //   name: LABELS.PARTNER,
    //   type: "text",
    //   width: "6%",
    //   editable: true,
    //   sortable: false,
    //   align: "center",
    // },
    {
      key: "name",
      name: LABELS.NAME,
      type: "text",
      width: "20%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "mobileNo",
      name: LABELS.MOBILE_NUMBER,
      type: "text",
      width: "10%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "homeAdd",
      name: LABELS.HOME_ADDRESS,
      type: "text",
      width: "24%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "birthDate",
      name: LABELS.DATE_OF_BIRTH,
      type: "date",
      width: "10%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "drivingLicense",
      name: LABELS.DRIVING_LICENSE,
      width: "10%",
      editable: true,
      sortable: false,
      align: "center",
      type: "text",
    },
    {
      key: "panNo",
      name: LABELS.PAN_NUMBER,
      type: "text",
      width: "10%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "aadharNo",
      name: LABELS.AADHAR_UID_NUMBER,
      type: "text",
      width: "10%",
      editable: true,
      sortable: false,
      align: "center",
    },
  ]);

  const [partnerRows, setPartnerRows] = useState<any[]>([]);

  const [familydeatilsColumn, setFamilyDetailsColumn] = useState<any>([
    // {
    //   key: "slno",
    //   name: LABELS.SL_NO,
    //   type: "text",
    //   width: "5%",
    //   editable: false,
    //   sortable: false,
    //   align: "center",
    // },
    {
      key: "name",
      name: LABELS.NAME,
      type: "text",
      width: "20%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "contact",
      name: LABELS.CONTACT,
      type: "text",
      width: "15%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "relation",
      name: LABELS.RELATION,
      type: "text",
      width: "15%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "address",
      name: LABELS.ADDRESS,
      type: "text",
      width: "50%",
      editable: true,
      sortable: false,
      align: "center",
    },
  ]);

  const [nomineedeatilsColumn, setNomineeDeatilsColumn] = useState<any>([
    // {
    //   key: "slno",
    //   name: LABELS.SL_NO,
    //   type: "text",
    //   width: "5%",
    //   editable: false,
    //   sortable: false,
    //   align: "center",
    // },
    {
      key: "fullName",
      name: LABELS.FULL_NAME,
      type: "text",
      width: "20%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "contact",
      name: LABELS.CONTACT,
      type: "text",
      width: "15%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "relation",
      name: LABELS.RELATION,
      type: "text",
      width: "15%",
      editable: true,
      sortable: false,
      align: "center",
    },
    {
      key: "address",
      name: LABELS.ADDRESS,
      type: "text",
      width: "50%",
      editable: true,
      sortable: false,
      align: "center",
    },
  ]);

  const [documentsCoulmn, setDocumnetsColumn] = useState<any>([
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "text",
      width: "5%",
      editable: false,
      sortable: false,
      align: "center",
    },
    {
      key: "document",
      name: LABELS.ENCLOSED_DOCUMENT,
      type: "text",
      width: "40%",
      editable: false,
      sortable: false,
      align: "center",
    },
    {
      key: "remarks",
      name: LABELS.REMARK,
      type: "text",
      width: "55%",
      editable: true,
      sortable: false,
      align: "center",
    },
  ]);

  const [vehicalDetailsCols, setVehicalDetailsCols] = useState<any[]>([
    {
      key: "no",
      name: "No.",
      type: "number",
      editable: true,
      width: "5%",
    },
    {
      key: "company",
      name: "Company",
      type: "text",
      editable: true,
      width: "25%",
    },
    {
      key: "model",
      name: "Model",
      type: "text",
      editable: true,
      width: "15%",
    },
    {
      key: "plateNo",
      name: "Plate No.",
      type: "text",
      editable: true,
      width: "15%",
    },
    {
      key: "packBody",
      name: "Pack Body",
      type: "text",
      editable: true,
      width: "20%",
    },
    {
      key: "gopalPaint",
      name: "Gopal Paint",
      type: "text",
      editable: true,
      width: "20%",
    },
  ]);

  const [vehicalDetailRows, setVehicalDetailRows] = useState<any[]>([]);

  const familydeatilsrow = [
    {
      id: "slno",
      slno: "1",
    },
  ];

  let documentRow = datajson.enclosedDocs[1];
  let nomineeRow = datajson.nomineeDetails[1];
  let familyDetailsRow = datajson.familyDetails[1];

  const manageLeadProfile = async () => {
    try {
      const firstName = (
        document.getElementById("firstName") as HTMLInputElement
      ).value.trim();
      const areaId = areasRef.current.selectedValue.id;
      const regAddress = (
        document.getElementById("regAddress") as HTMLInputElement
      ).value.trim();
      const city = (
        document.getElementById("city") as HTMLInputElement
      ).value.trim();
      const taluka = (
        document.getElementById("taluka") as HTMLInputElement
      ).value.trim();
      const district = (
        document.getElementById("district") as HTMLInputElement
      ).value.trim();
      const zone = (
        document.getElementById("zone") as HTMLInputElement
      ).value.trim();

      const state = (
        document.getElementById("state") as HTMLInputElement
      ).value.trim();
      const pinNo = (
        document.getElementById("pinNo") as HTMLInputElement
      ).value.trim();

      const emailId = (
        document.getElementById("emailId") as HTMLInputElement
      ).value.trim();
      const firmPAN = (
        document.getElementById("firmPAN") as HTMLInputElement
      ).value.trim();

      const religion = (
        document.getElementById("religion") as HTMLInputElement
      ).value.trim();

      const firmGST = (
        document.getElementById("firmGST") as HTMLInputElement
      ).value.trim();
      const fssiNo = (
        document.getElementById("fssiNo") as HTMLInputElement
      ).value.trim();

      const busStartDate = (
        document.getElementById("busStartDate") as HTMLInputElement
      ).value.trim();
      let type = document.querySelector(
        'input[name="Status"]:checked'
      ) as HTMLInputElement;
      const Status = type ? type.value : "";
      const personName = (
        document.getElementById("personName") as HTMLInputElement
      ).value.trim();

      const mobileNo1 = (
        document.getElementById("mobileNo1") as HTMLInputElement
      ).value.trim();
      const personName2 = (
        document.getElementById("personName2") as HTMLInputElement
      ).value.trim();

      const mobileNo2 = (
        document.getElementById("mobileNo2") as HTMLInputElement
      ).value.trim();
      // area
      const areaVillage = (
        document.getElementById("areaVillage") as HTMLInputElement
      ).value.trim();
      const talukaArea = (
        document.getElementById("talukaArea") as HTMLInputElement
      ).value.trim();
      const districtArea = (
        document.getElementById("districtArea") as HTMLInputElement
      ).value.trim();
      const stateArea = (
        document.getElementById("stateArea") as HTMLInputElement
      ).value.trim();

      //PERSONAL details
      const name = (
        document.getElementById("name") as HTMLInputElement
      ).value.trim();
      const mobileNo = (
        document.getElementById("mobileNo") as HTMLInputElement
      ).value.trim();
      const homeAddress = (
        document.getElementById("homeAddress") as HTMLInputElement
      ).value.trim();
      const birthDate = (
        document.getElementById("birthDate") as HTMLInputElement
      ).value.trim();
      const drivingLicense = (
        document.getElementById("drivingLicense") as HTMLInputElement
      ).value.trim();
      const panNo = (
        document.getElementById("panNo") as HTMLInputElement
      ).value.trim();
      const aadharUIDNo = (
        document.getElementById("aadharUIDNo") as HTMLInputElement
      ).value.trim();
      //PARTNER details

      //STORAGE
      const sqFt = (
        document.getElementById("sqFt") as HTMLInputElement
      ).value.trim();
      const address = (
        document.getElementById("address") as HTMLInputElement
      ).value.trim();
      const talukaStorage = (
        document.getElementById("talukaStorage") as HTMLInputElement
      ).value.trim();
      const districtStorage = (
        document.getElementById("districtStorage") as HTMLInputElement
      ).value.trim();
      const stateStorage = (
        document.getElementById("stateStorage") as HTMLInputElement
      ).value.trim();
      //BANK
      const accName = (
        document.getElementById("accName") as HTMLInputElement
      ).value.trim();
      const accNo = (
        document.getElementById("accNo") as HTMLInputElement
      ).value.trim();
      const bankName = (
        document.getElementById("bankName") as HTMLInputElement
      ).value.trim();
      const branch = (
        document.getElementById("branch") as HTMLInputElement
      ).value.trim();
      const typeOFAcc = (
        document.getElementById("typeOFAcc") as HTMLInputElement
      ).value.trim();
      const ifscNo = (
        document.getElementById("ifscNo") as HTMLInputElement
      ).value.trim();

      //reference
      const appointedBy = (
        document.getElementById("appointedBy") as HTMLInputElement
      ).value.trim();

      //deposit detail
      const amount = (
        document.getElementById("amount") as HTMLInputElement
      ).value.trim();
      const depositeDate = (
        document.getElementById("depositeDate") as HTMLInputElement
      ).value.trim();

      ///other family

      ///Nominee details

      //COMPANY
      const argsCompany = {
        firmName: firstName,
        areaId,
        regAddress,
        city,
        taluka,
        district,
        zone,
        state,
        pinNo,
        emailId,
        firmPAN,
        religion,
        firmGST,
        fssiNo,
        busStartDate,
        Status,
        personName,
        mobileNo1,
        personName2,
        mobileNo2,
      };

      // area
      const argsArea = {
        areaVillage,
        talukaArea,
        districtArea,
        stateArea,
      };

      //PERSONAL
      const argsPersonal = {
        name,
        mobileNo,
        homeAddress,
        birthDate,
        drivingLicense,
        panNo,
        aadharUIDNo,
      };

      //partner

      //STORAGE
      const argsStorage = {
        sqFt,
        address,
        talukaStorage,
        districtStorage,
        stateStorage,
      };

      //BANK
      const argsBank = {
        accName,
        accNo,
        bankName,
        branch,
        typeOFAcc,
        ifscNo,
      };

      //reference
      const argsReference = {
        appointedBy,
      };

      //DEPOSIT DETAIL
      const argsDeposit = {
        amount,
        depositeDate,
      };

      //OTHER FAMILY

      // NOMIEE DETAILS

      // VEHICAL DETAIL
      const argsVehicle = { items: gridRef.getRowData() };

      console.log("json data", datajson.enclosedDocs[1]);

      const args = {
        crmLeadId: selectedRow.id,
        crmLeadName: selectedRow.crmLeadName,
        activeStatus: "true",
        crmLeadStatus: CRM_LEAD_STATUS.QUALIFIED,
        companyDetails: argsCompany,
        areaDetails: argsArea,
        storageDetails: argsStorage,
        bankDetails: argsBank,
        referenceDetails: argsReference,
        depositDetails: argsDeposit,
        vehicleDetails: argsVehicle,
      };

      // Validations
      if (!argsCompany.areaId) {
        COMMON_JS.showNotify(
          props,
          NOTIFY.WARNING,
          WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
        );
        return;
      }
      if (!argsCompany.fssiNo) {
        COMMON_JS.showNotify(
          props,
          NOTIFY.WARNING,
          WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
        );
        return;
      }
      if (!argsCompany.busStartDate) {
        COMMON_JS.showNotify(
          props,
          NOTIFY.WARNING,
          WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
        );
        return;
      }

      const res = await CRM_APIs.manageCrmLeadProfile(args);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        onClose();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
      }
    } catch (error) {
      console.error("manageCrmLeadProfile: error:", error);
    }
  };

  const getDefaultNomineeNewRow = () => {
    const newRow: any = {
      id: "1." + (gridRef.getRowData().length + 1),
      slno: (nomineeGridRef.getRowData().length + 1).toString(),
      fullName: "",
      contact: "",
      Relation: "",
      Address: "",
    };
    return newRow;
  };
  const getDefaultFamilyNewRow = () => {
    const newRow: any = {
      id: "1." + (gridRef.getRowData().length + 1),
      slno: (familyGridRef.getRowData().length + 1).toString(),
      name: "",
      contact: "",
      Relation: "",
      Address: "",
    };
    return newRow;
  };

  const onAdd = () => {};

  const getDefaultNewRow = () => {
    const newRow: any = {
      id: "1.8.1." + (gridRef.getRowData().length + 1),
      no: "",
      company: "",
      model: "",
      plateNo: "",
      packBody: "",
      gopalPaint: "",
    };
    return newRow;
  };
  return (
    <React.Fragment>
      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"1. " + LABELS.COMPANY_DEATAIL}</h4>
        </div>
        <div className="flexColumn">
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"firstName"}
                label={LABELS.FIRM_NAME}
                defaultValue={selectedRow.firstName}
              />
            </div>
            <div className="formGroup width30 required">
              <label>
                {LABELS.AREA}
                <span>{" *"}</span>
              </label>
              <AutoComplete
                list={areas}
                childRef={areasRef}
                required={true}
                // defaultValue={{
                //   id: props.userInfo.empId,
                //   label: props.userInfo.empName,
                // }}
                // disabled={true}
              />
            </div>
            {/* <div className="formGroup width30">
              <TxtRow
                id={"area"}
                label={LABELS.AREA}
                defaultValue={selectedRow.area}
              />
            </div> */}
            <div className="formGroup width30">
              <TxtRow
                id={"regAddress"}
                label={LABELS.REG_ADDRESS}
                defaultValue={selectedRow.regAddress}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"city"}
                label={LABELS.CITY}
                defaultValue={selectedRow.city}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"taluka"}
                label={LABELS.TALUKA}
                defaultValue={selectedRow.taluka}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"district"}
                label={LABELS.DISTRICT}
                defaultValue={selectedRow.district}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"zone"}
                label={LABELS.ZONE}
                defaultValue={selectedRow.zone}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"state"}
                label={LABELS.STATE}
                defaultValue={selectedRow.state}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"pinNo"}
                label={LABELS.PIN_NO}
                defaultValue={selectedRow.pinNo}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"emailId"}
                label={LABELS.EMAIL_ID}
                defaultValue={selectedRow.emailId}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"firmPAN"}
                label={LABELS.FIRM_PAN}
                defaultValue={selectedRow.firmPAN}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"religion"}
                label={LABELS.RELIGION}
                defaultValue={selectedRow.religion}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"firmGST"}
                label={LABELS.FIRM_GST}
                defaultValue={selectedRow.firmGST}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"fssiNo"}
                label={LABELS.FSSI_NO}
                defaultValue={selectedRow.fssiNo}
                required={true}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"busStartDate"}
                label={LABELS.BUS_START_DATE}
                type="date"
                defaultValue={selectedRow.busStartDate}
                required={true}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30 ">
              <label>{LABELS.STATUS}</label>
              <RadioBtn
                list={[
                  {
                    id: "Proprietor",
                    value: "Proprietor",
                    label: LABELS.PROPRIETOR,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "Partnership",
                    value: "Partnership",
                    label: LABELS.PARTNERSHIP,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === false
                      : false,
                    disabled: false,
                  },
                  {
                    id: "Pvt. Ltd",
                    value: "Pvt. Ltd",
                    label: LABELS.PVT_LTD,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === false
                      : false,
                    disabled: false,
                  },
                  {
                    id: "Ltd",
                    value: "Ltd.",
                    label: LABELS.LTD,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"Status"}
              />
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>
        </div>
      </div>

      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"2. " + LABELS.CONTACT}</h4>
        </div>
        <div className="flexRowAround">
          <div className="formGroup width30">
            <TxtRow
              id={"personName"}
              label={LABELS.CONTACT_PERSON_1_NAME}
              defaultValue={selectedRow.personName}
            />
          </div>
          <div className="formGroup width30">
            <TxtRow
              id={"mobileNo1"}
              label={LABELS.CONTACT_PERSON_1_MOBILE}
              defaultValue={selectedRow.mobileNo1}
            />
          </div>
          <div className="formGroup width30"></div>
        </div>
        <div className="flexRowAround">
          <div className="formGroup width30">
            <TxtRow
              id={"personName2"}
              label={LABELS.CONTACT_PERSON_2_NAME}
              defaultValue={selectedRow.personName}
            />
          </div>
          <div className="formGroup width30">
            <TxtRow
              id={"mobileNo2"}
              label={LABELS.CONTACT_PERSON_2_MOBILE}
              defaultValue={selectedRow.mobileNo}
            />
          </div>
          <div className="formGroup width30"></div>
        </div>
      </div>

      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"3. " + LABELS.AREA_DEATAIL}</h4>
        </div>
        <div className="flexColumn">
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"areaVillage"}
                label={LABELS.AREA_VILLAGE}
                defaultValue={selectedRow.areaVillage}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"talukaArea"}
                label={LABELS.TALUKA}
                defaultValue={selectedRow.taluka}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"districtArea"}
                label={LABELS.DISTRICT}
                defaultValue={selectedRow.district}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"stateArea"}
                label={LABELS.STATE}
                defaultValue={selectedRow.state}
              />
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>
        </div>
      </div>

      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"4. " + LABELS.PERSONAL_DEATIL}</h4>
        </div>
        <div className="flexColumn">
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"name"}
                label={LABELS.NAME}
                defaultValue={selectedRow.name}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"mobileNo"}
                label={LABELS.MOBILE_NUMBER}
                defaultValue={selectedRow.mobileNo}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"homeAddress"}
                label={LABELS.HOME_ADDRESS}
                defaultValue={selectedRow.homeAddress}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"birthDate"}
                label={LABELS.DATE_OF_BIRTH}
                defaultValue={selectedRow.birthDate}
                type="date"
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"drivingLicense"}
                label={LABELS.DRIVING_LICENSE}
                defaultValue={selectedRow.drivingLicense}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"panNo"}
                label={LABELS.PAN_NUMBER}
                defaultValue={selectedRow.panNo}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"aadharUIDNo"}
                label={LABELS.AADHAR_UID_NUMBER}
                defaultValue={selectedRow.aadharUIDNo}
              />
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>
        </div>
      </div>

      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"5. " + LABELS.PARTNER_DETAIL}</h4>
        </div>
        <div className="flexRowAround">
          <ExcelGrid
            height={600}
            childRef={partnerGridRef}
            cols={partnerColumns}
            rows={partnerRows}
            exportOption={false}
            newRowOption={false}
            getDefaultNewRow={getDefaultNewRow}
          />
        </div>
      </div>

      <div className="formGroupBox ">
        <div className="formGroupTitle">
          <h4>{"6. " + LABELS.WAREHOUSE_DETAIL}</h4>
        </div>
        <div className="flexColumn">
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"sqFt"}
                label={LABELS.SQ_FT}
                defaultValue={selectedRow.sqFt}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"address"}
                label={LABELS.ADDRESS}
                defaultValue={selectedRow.address}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"talukaStorage"}
                label={LABELS.TALUKA}
                defaultValue={selectedRow.talukaStorage}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"districtStorage"}
                label={LABELS.DISTRICT}
                defaultValue={selectedRow.districtStorage}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"stateStorage"}
                label={LABELS.STATE}
                defaultValue={selectedRow.stateStorage}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </div>
      </div>

      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"7. " + LABELS.BANK_DEATIL}</h4>
        </div>
        <div className="flexColumn">
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"accName"}
                label={LABELS.ACCOUNT_NAME}
                defaultValue={selectedRow.accName}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"accNo"}
                label={LABELS.ACCOUNT_NUMBER}
                defaultValue={selectedRow.accNo}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"bankName"}
                label={LABELS.BANK_NAME}
                defaultValue={selectedRow.bankName}
              />
            </div>
          </div>

          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"branch"}
                label={LABELS.BRANCH}
                defaultValue={selectedRow.branch}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"typeOFAcc"}
                label={LABELS.TYPE_OF_ACCOUNT}
                defaultValue={selectedRow.typeOFAcc}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"ifscNo"}
                label={LABELS.IFSC_NO}
                defaultValue={selectedRow.ifscNo}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="formGroupBox ">
        <div className="formGroupTitle">
          <h4>{"8. " + LABELS.REFERENCE}</h4>
        </div>
        <div className="flexRowAround">
          <div className="formGroup width30">
            <TxtRow
              id={"appointedBy"}
              label={LABELS.APPOINTED_BY}
              defaultValue={selectedRow.appointedBy}
            />
          </div>
          <div className="formGroup width30"></div>
          <div className="formGroup width30"></div>
        </div>
      </div>

      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"9. " + LABELS.DEPOSIT_DETAIL}</h4>
        </div>
        <div className="flexColumn">
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"amount"}
                label={LABELS.AMOUNT}
                defaultValue={selectedRow.amount}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"depositeDate"}
                label={LABELS.DEPOSIT_DATE}
                type="date"
                // defaultValue={
                //   selectedRow.depositeDate
                //     ? DateFunctions.getFormatedDate(
                //         selectedRow.depositeDate,
                //         FORMATS.SQL_DATE,
                //         FORMATS.SQL_DATE_ONLY
                //       )
                //     : DateFunctions.getDate(
                //         "today",
                //         "from",
                //         FORMATS.SQL_DATE_ONLY
                //       )
                // }
              />
            </div>

            <div className="formGroup width30"></div>
          </div>
        </div>
      </div>

      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"10. " + LABELS.OTHER_FAMILY}</h4>
        </div>
        <div className="flexRowAround">
          <ExcelGrid
            height={600}
            childRef={familyGridRef}
            cols={familydeatilsColumn}
            rows={familyDetailsRow}
            exportOption={false}
            newRowOption={false}
            getDefaultNewRow={getDefaultFamilyNewRow}
          />
        </div>
      </div>

      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"11. " + LABELS.NOMINEE_DETAILS}</h4>
        </div>
        <div className="flexRowAround">
          <ExcelGrid
            height={600}
            childRef={nomineeGridRef}
            cols={nomineedeatilsColumn}
            rows={nomineeRow}
            exportOption={false}
            newRowOption={false}
            getDefaultNewRow={getDefaultNomineeNewRow}
          />
        </div>
      </div>

      {/* vehicle details */}
      <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{"12. " + LABELS.VEHICAL_DETAILS}</h4>
        </div>
        <div className="flexRowAround">
          <ExcelGrid
            height={600}
            childRef={gridRef}
            cols={vehicalDetailsCols}
            rows={vehicalDetailRows}
            exportOption={false}
            newRowOption={false}
            //onAdd={onAdd}
            getDefaultNewRow={getDefaultNewRow}
          />
        </div>
      </div>

      <div style={{ marginTop: "-1rem" }}>
        <ul style={{ paddingLeft: "20px" }}>
          <li style={{ margin: "5px 5px" }}>
            {
              "I/We certify that the information provided in the form is correct and complete."
            }
          </li>
          <li style={{ margin: "5px 5px" }}>
            {
              "Further, This is to authorise Gopal Snacks Pvt. Ltd. To verify our Bank and other details as provided."
            }
          </li>
          <li style={{ margin: "5px 5px" }}>
            {
              "Dealer/Agency signature attests financial responsibility to pay Gopal Snacks Pvt. Ltd. Invoices in accordance with agreed upon T&C."
            }
          </li>
          <li style={{ margin: "5px 5px" }}>
            {
              'Dealer rules form "Niyam Patrak" should be signed along with this Document and Dealer have to obey the same.'
            }
          </li>
        </ul>
      </div>

      <div className="flexRowAround width100">
        <ExcelGrid
          height={700}
          cols={documentsCoulmn}
          rows={documentRow}
          exportOption={false}
          newRowOption={false}
        />
      </div>

      {/* <div className="formGroupBox">
        <div className="formGroupTitle">
          <h4>{LABELS.DOCUMENT_DETAILS}</h4>
        </div>
      </div> */}

      <div
        className="formGroup submitBtnWrapper"
        style={{ marginBottom: "2rem" }}
      >
        <div className="width45 flexRowAround ">
          <Btn text={LABELS.SAVE} onClick={manageLeadProfile} />
          {/* <Btn text={LABELS.CANCEL} bgColor={COLORS.DIM_DARK_GRAY} /> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(Qualified);
